<template>
  <div>
  </div>
</template>

<script>
export default {
  name: 'GoliveLogin',
  data () {
    return {
      msg: 'Welcome to Your Vue.js PWA'
    }
  },
  mounted(){
    var xauthid = this.$route.params.xAuthId;
    var url = "/"+this.$route.params.urlToRedirect
    this.$cookie.set('X-Auth-Id',xauthid)
    this.$router.push(url)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>
